/**
 * A lightweight, non-sensitive "did this browser ever have a session" flag.
 *
 * The refresh-token cookie is HttpOnly (by design -- JS must never read it)
 * AND cross-origin from the frontend's own page (backend and frontend run on
 * different ports/hosts), so there is no way for the frontend to check
 * client-side whether a valid refresh cookie exists before asking the server.
 * Without this hint, EVERY page load -- including a brand-new visitor who has
 * never logged in -- fires a POST /auth/refresh that predictably 401s, which
 * shows up as a red network error in the console for every anonymous visitor.
 *
 * This flag carries no secret and grants nothing by itself -- the server
 * still fully validates the real HttpOnly cookie on every refresh attempt.
 * It's purely a hint to skip a network call we already know will fail.
 */

const KEY = "arteria_had_session";

export const hasSessionHint = (): boolean => {
  try {
    return localStorage.getItem(KEY) === "1";
  } catch {
    // If localStorage is unavailable, err on the side of still trying the
    // silent refresh -- worse DX (one noisy 401), never worse security.
    return true;
  }
};

export const setSessionHint = (): void => {
  try {
    localStorage.setItem(KEY, "1");
  } catch {
    /* localStorage unavailable */
  }
};

export const clearSessionHint = (): void => {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* localStorage unavailable */
  }
};
